<template>
  <Tenant v-show="active == 'tenant'" @change-active="handleActive"/>
  <Label v-if="active == 'label'" @change-active="handleActive"/>
</template>

<script>
import Tenant from "./tenant.vue";
import Label from "./label.vue";

export default {
  components: {
    Tenant,
    Label,
  },
  data(){
    return {
      active: "tenant",
    }
  },
  methods: {
    handleActive(active){
      this.active = active;
    }
  }
}
</script>

<style scoped lang="less">

</style>
